const {classList} = require("helpers/html");

function RatingTbd({className}) {
	return (
		<div className={classList("rating tbd", className)}>TBD</div>
	);
}

module.exports = RatingTbd;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/RatingTbd.js